import { createContext, ReactNode, useContext } from 'react';

interface INewContentCardContext {
  contentType: 'lesson' | 'exercise' | 'material' | 'essay';
  contentId: string;
  contentSlug: string;
  discipline: string;
  subject?: string;
}

const NewContentCardContext = createContext<INewContentCardContext>(
  {} as INewContentCardContext
);

export function useNewContentCardContext() {
  return useContext(NewContentCardContext);
}

interface INewContentCardProviderProps extends INewContentCardContext {
  children?: ReactNode;
}

export function NewContentCardProvider(props: INewContentCardProviderProps) {
  return (
    <NewContentCardContext.Provider
      value={{
        contentType: props.contentType,
        contentId: props.contentId,
        contentSlug: props.contentSlug,
        subject: props.subject,
        discipline: props.discipline,
      }}
    >
      {props.children}
    </NewContentCardContext.Provider>
  );
}
